import { useEffect } from 'react';

import * as LogRocket from 'src/lib/logrocket';
import { useCurrentCustomer, useCurrentUser } from 'src/store';

/**
 * Identify user and customer in tracking services
 */
export const UserAnalyticsUpdater = () => {
  const currentUser = useCurrentUser();
  const currentCustomer = useCurrentCustomer();

  useEffect(() => {
    if (!currentUser || !currentCustomer) {
      return;
    }

    // We should actually "start" LogRocket recording only when user is logged-in
    // also, do not record LogRocket sessions for Keywee/Anyword users
    if (!currentUser.isKeywee) {
      LogRocket.start();
    }

    LogRocket.identifyUser({
      user: currentUser,
      customer: currentCustomer,
    });
  }, [currentUser, currentCustomer]);

  return null;
};
